import { ApiFunc, getInstance } from '@helpers/httpClient'

import * as API from '../constants/api'

const instance = getInstance()

export const reservationRoomList: ApiFunc<`${typeof API.RESERVATION_ROOM}`, 'get'> = data =>
  instance.get(API.RESERVATION_ROOM, { params: data })

export const reservationRoomAll: ApiFunc<`${typeof API.RESERVATION_ROOM_ALL}`, 'get'> = data =>
  instance.get(API.RESERVATION_ROOM_ALL, { params: data })

export const reservationRoomCreate: ApiFunc<`${typeof API.RESERVATION_ROOM}`, 'post'> = data =>
  instance.post(API.RESERVATION_ROOM, data)

export const reservationRoomDelete: ApiFunc<`${typeof API.RESERVATION_ROOM}{id}`, 'delete'> = data =>
  instance.delete(`${API.RESERVATION_ROOM}${'id' in data ? data.id : data?.name}`)

export const reservationTimeSlotAll: ApiFunc<`${typeof API.RESERVATION_TIME_SLOT_ALL}`, 'get'> = data =>
  instance.get(`${API.RESERVATION_TIME_SLOT_ALL}`, { params: data })

export const roomReservationCreate: ApiFunc<`${typeof API.ROOM_RESERVATION}`, 'post'> = data =>
  instance.post(`${API.ROOM_RESERVATION}`, data)

export const roomReservationAll: ApiFunc<`${typeof API.ROOM_RESERVATION_ALL}`, 'get'> = data =>
  instance.get(`${API.ROOM_RESERVATION_ALL}`, { params: data })

export const roomReservationDelete: ApiFunc<`${typeof API.ROOM_RESERVATION}{id}`, 'delete'> = data =>
  instance.delete(`${API.ROOM_RESERVATION}${'id' in data ? data.id : data?.name}`)
